import { Button, Input, Space, Tag, Typography, Pagination } from "antd";
import { Link, useLocation } from "wouter";
import { useEffect, useMemo, useState, useCallback } from "react";
import { DeleteOutlined, EditFilled } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { DraftOrdersListAPI } from "../../../redux/actions/adminActions/listsAction";
import Alertify from "../../../services/alertify";
import CommonAdminTable from "../../components/commonTable";
import { getQueryParams } from "../../../utilities/getQueryParams";
import { DeleteOrderDraft } from "../../../redux/actions/adminActions/newOrderRequestAction";
import { LoaderIcon } from "react-hot-toast";

const { Title } = Typography;

const OrderDraftList = () => {
  const [searchValue, setSearchValue] = useState("");
  const [totalOrders, setTotalOrders] = useState(0);

  const dispatch = useDispatch();

  useEffect(() => {
    document.title = "Draft Orders: ALP Shop";
  }, []);
  const [, navigate] = useLocation();
  const params = getQueryParams();
  const initialPage = params.page || 1;
  const [currentPage, setCurrentPage] = useState(initialPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/admin/order-drafts?page=${page}`);
  };
  const fetchOrderRequests = useCallback(() => {
    const data = {
      search: searchValue,
      page: currentPage,
    };
    // setIsLoading(true);
    setLoading(true);
    dispatch(DraftOrdersListAPI(data))
      .then((response) => {
        // console.log("List is-----:", response);
        const total = response?.payload?.data?.pagination?.total || 0;
        setTotalOrders(total);
        // console.log("Total orders", total);
        setLoading(false);
      })
      .catch((error) => {
        Alertify.error("Failed to fetch Draft Orders List: " + error.message);
        setLoading(false);
      });
  }, [dispatch, searchValue, currentPage]);
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchOrderRequests();
    }, 300); // Delay of 300 milliseconds for debouncing

    return () => {
      clearTimeout(handler);
    };
  }, [fetchOrderRequests]);

  const orderRequests = useSelector((state) => state.all_lists);

  const all_order_requests = useMemo(() => {
    return orderRequests.all_draft_orders_list || [];
  }, [orderRequests]);
  const [loading, setLoading] = useState(true);
  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      key: "index",
      align: "center",
      render: (text, record, index) => (currentPage - 1) * 10 + index + 1,
    },
    {
      title: "UUID",
      dataIndex: "uuid",
      key: "uuid",
      hidden: true,
      fixed: "left",
      render: (text) => <Link to="#">{text}</Link>,
    },
    {
      title: "User",
      dataIndex: "details",
      key: "dealerName",
      render: (details) => <Link to="#">{details?.dealerName}</Link>,
    },
    {
      title: "Order Type",
      dataIndex: "details",
      key: "orderType",
      render: (details) => <Link to="#">{details?.orderType}</Link>,
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (status) => {
        let color = status === "approved" ? "geekblue" : "geekblue";
        return (
          <Tag color={color} key={status}>
            Draft
          </Tag>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (record) => (
        <Space size="middle">
          <Link
            to={`/admin/order-requests/new-order?UUID=${record.uuid}`}
            className="text-blue-700"
          >
            <EditFilled className="me-2" />
            Edit
          </Link>
          <p
            onClick={() => {
              setLoading(true);
              const draftDeleteReqData = {
                uuid: record.uuid,
              };
              dispatch(DeleteOrderDraft(draftDeleteReqData))
                .then((response) => {
                  fetchOrderRequests();
                })
                .finally(() => {
                  setLoading(false);
                });
            }}
            className="text-red-600 cursor-pointer"
          >
            <DeleteOutlined className="me-2" />
            Delete
          </p>
        </Space>
      ),
    },
  ];

  // Add a unique key to each order request
  const dataSource = all_order_requests.map((order, index) => ({
    ...order,
    key: order.orderId || index, // Use orderId or index as a fallback key
  }));

  return (
    <>
      <Title level={2} className="text-left">
        Order Drafts
      </Title>
      <div className="mb-8 flex items-center justify-between max-sm:flex-col max-sm:gap-4">
        <div className="sm:w-1/3">
          <Input
            placeholder="Search"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
        <Link to="/admin/order-requests/new-order">
          <Button type="primary" className="rounded-md">
            NEW ORDER REQUEST +
          </Button>
        </Link>
      </div>
      {loading ? (
        <div className="flex items-center justify-center pt-60">
          <LoaderIcon className="w-[3vw] h-[3vw] " />
        </div>
      ) : (
        <>
          <CommonAdminTable columns={columns} data={dataSource} />
          <div className="flex justify-between items-center mt-4">
            <Pagination
              current={currentPage}
              total={totalOrders} // Use totalOrders state
              pageSize={10}
              onChange={handlePageChange}
              showSizeChanger={false}
            />
          </div>
        </>
      )}
    </>
  );
};

export default OrderDraftList;
